import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'

export default class CustomButton extends Component {
    constructor(props) {
        super(props);
    }
    state = {}

    componentDidMount = () => {

    }

    render() {
        const {
            customButton
        } = this.props

        return (
            <Wrapper>
                <ContainerWrapper fluid>
                    <BtnWrapper position={customButton[0].position}>
                        <Btn
                            width={customButton[0].width}
                            height={customButton[0].height}
                            color={customButton[0].color}
                            href={customButton[0].url}
                        >
                            <BtnText>{customButton[0].text}</BtnText>
                            {customButton[0].text_translation &&
                                <Desc>{customButton[0].text_translation}</Desc>
                            }

                        </Btn>
                    </BtnWrapper>
                </ContainerWrapper>
            </Wrapper>
        )
    }
}

//Styles
const Wrapper = styled.div`
`
const Desc = styled.p`
//line-height: 100px !important;
margin-bottom: 0;
font-size: 0.9em;
`
const BtnText = styled.p`
margin-bottom: 0;
`

const ContainerWrapper = styled(Container)`
padding: 0 20%;
`
const BtnWrapper = styled.div`
width: 100%;
display: flex;
justify-content: ${props => props.position};
`

const Btn = styled.a`
display: flex;
flex-direction: column;
justify-content: center;
width: 100%;
height: ${props => props.height};
background-color: ${props => props.color};
border-radius: ${props => props.height.substring(0, props.height.length - 2) + 5}px;
//line-height: ${props => props.height}
text-align: center;
color: white;
cursor: pointer;
margin-bottom: 20px;
text-transform: uppercase;
text-decoration: none;

:hover {
    opacity: 0.9;
    color: white;
}

${media.md`
width: ${props => props.width};
`}
`





// WEBPACK FOOTER //
// ./src/ui/components/modules/Button/index.js